export const refreshAds = () => {
  if (document && CustomEvent && typeof document.dispatchEvent === 'function') {
    document.dispatchEvent(new CustomEvent('mesoTriggeredRefresh', {
      detail: {
        type: 'impressionRefresh'
      }
    }));
  }
};